import { render, staticRenderFns } from "./pdfViewerDocPengiriman.vue?vue&type=template&id=4d6699a4&scoped=true&"
import script from "./pdfViewerDocPengiriman.vue?vue&type=script&lang=js&"
export * from "./pdfViewerDocPengiriman.vue?vue&type=script&lang=js&"
import style0 from "./pdfViewerDocPengiriman.vue?vue&type=style&index=0&id=4d6699a4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d6699a4",
  null
  
)

export default component.exports